export default "__VITE_ASSET__BAmJDfUb__"